
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"16","height":"16","rx":"8","fill":"#008C89","fill-opacity":".16"}}),_c('g',{attrs:{"clip-path":"url(#clip0_6223_49801)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.158 4.038c-1.203.158-2.402.434-3.303.76-.72.261-1.339.595-1.761.95a3.778 3.778 0 00-1.212 2.003c-.164.754-.046 1.587.312 2.21l.099.171-.609.61c-.448.45-.618.634-.647.696a.395.395 0 00.525.524c.063-.028.246-.198.698-.65l.614-.612.056.04c.031.022.14.082.243.134.87.435 1.924.421 2.877-.038a3.619 3.619 0 001.466-1.286c.584-.878 1.033-2.216 1.336-3.983.087-.505.155-1.059.147-1.197a.364.364 0 00-.2-.328c-.104-.055-.252-.056-.641-.004zm-.02.867c0 .132-.15.972-.265 1.487-.264 1.175-.604 2.083-1.014 2.708a3.256 3.256 0 01-1.168 1.025 2.482 2.482 0 01-2.071.077 1.134 1.134 0 01-.138-.067c-.018-.014.202-.245.906-.95.705-.706.94-.952.968-1.016a.395.395 0 00-.524-.525c-.064.029-.31.264-1.018.97l-.933.932-.056-.11c-.193-.387-.266-.952-.184-1.417.139-.788.677-1.539 1.417-1.975.813-.48 2.102-.88 3.592-1.116.17-.027.323-.051.338-.055a.665.665 0 01.09-.008c.051-.002.06.004.06.04z","fill":"#008C89"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_6223_49801"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(4 4)","d":"M0 0h8v8H0z"}})])])])
          )
        }
      }
    